import { render, staticRenderFns } from "./loader-fail.vue?vue&type=template&id=54dc406c&scoped=true&"
import script from "./loader-fail.vue?vue&type=script&lang=js&"
export * from "./loader-fail.vue?vue&type=script&lang=js&"
import style0 from "./loader-fail.vue?vue&type=style&index=0&id=54dc406c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dc406c",
  null
  
)

export default component.exports